import React, { Component } from "react";
import {withRouter, Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import ReactPaginate from 'react-paginate';

import {PageWrapper} from 'components/PageWrapper';

import HttpClient from 'services/HttpClient';

const MCQ_THEMES_API = '/api/v1/themes';

@withRouter
@inject('mcqThemesStore')
@observer
class McqThemes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPages: 1,
    };
  }

  componentDidMount() {
    const { mcqThemesStore } = this.props;

    new HttpClient().get(`${MCQ_THEMES_API}?page=1&per_page=10`)
    .then(({ body }) => {
      mcqThemesStore.setMcqThemes(body.data.theme);

      this.setState({
        totalPages: body.data.total_pages,
      });
    })
  }

  nextPage = page => {
    const { mcqThemesStore } = this.props;

    new HttpClient().get(`${MCQ_THEMES_API}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      mcqThemesStore.setMcqThemes(body.data.theme);

      this.setState({
        totalPages: body.data.total_pages,
      });
      window.scrollTo({top: 0});
    });
  };

  render() {
    const { mcqThemesStore: { mcq_themes } } = this.props;
    const { totalPages } = this.state;

    return (
      <PageWrapper>
        <div className="page-container">
          <h2>MCQ Themes</h2>
        </div>
        <Link to='/mcq-themes/add'>+ Add New Theme</Link>
        <div className="row">
          <div className="container">
            <div className="mcq-questions-list">
              {mcq_themes.length > 0 ? mcq_themes.map((theme) => (
                <Link
                  to={`/mcq-themes/${theme.id}/edit`}
                  key={`theme_${theme.id}`}
                >
                  {theme.title}
                </Link>
              )) : (
                <div className="empty-list-container">
                  <span className="self-center">There is no themes</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="pagination-container">
          <ReactPaginate
            containerClassName="react-paginate"
            pageCount={totalPages}
            onPageChange={this.nextPage}
          />
        </div>
      </PageWrapper>
    );
  }
};

export default McqThemes;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqThemes/containers/McqThemes.js